import React, { useState } from 'react';
import { FormControl, TextField, Button } from '@mui/material';
import { useOutletContext } from "react-router-dom";

export default function MappingNew() {
    const { getMappings } = useOutletContext();
    const [data, setData] = useState({
        name: '',
        description: ''
    });

    async function saveMapping() {
        try {
            const response = await fetch('/api/mapping', {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            });
            if (response.ok) {
                const result = await response.json();
                getMappings(1); // Refresh the mappings list
            } else {
                console.error('Failed to save mapping');
            }
        } catch (error) {
            console.error('Error saving mapping:', error);
        }
    }

    const handleNameChange = (event) => {
        setData(prevData => ({
            ...prevData,
            name: event.target.value
        }));
    }

    const handleDescriptionChange = (event) => {
        setData(prevData => ({
            ...prevData,
            description: event.target.value
        }));
    }

    const handleSave = () => {
        if (data.name.trim() === '') {
            alert('Name is required');
            return;
        }
        saveMapping();
        getMappings(1); // Refresh the mappings list after saving
    }

    return (
        <div>
            <h4>New Mapping</h4>
            <FormControl fullWidth margin="normal">
                <TextField
                    label="Name"
                    id='mapping-name'
                    name='mapping-name'
                    type="text"
                    value={data.name}
                    onChange={handleNameChange}
                />
            </FormControl>
            <FormControl fullWidth margin="normal">
                <TextField
                    label="Description"
                    id='mapping-description'
                    name='mapping-description'
                    type="text"
                    multiline
                    minRows={4}
                    maxRows={10}
                    value={data.description}
                    onChange={handleDescriptionChange}
                />
            </FormControl>
            <Button variant="contained" color="primary" onClick={handleSave}>
                Save 
            </Button>
        </div>
    )
}
